import {Component, HostListener} from '@angular/core';
import {CommunicationService} from '../services/communication.service';
import {LocalStorageService} from '../services/local-storage.service';
import {UserService} from '../services/user.service';
import {CommonService} from '../services/common.service';

@Component({
  selector: 'app-impressum',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.scss'],
})
export class ImpressumComponent {
  isLogin: boolean;

  constructor(
    private commonService: CommonService,
    private communicationService: CommunicationService,
    private localStorageService: LocalStorageService,
    private userService: UserService,
  ) {
    this.isLogin = !this.localStorageService.getItem('technician_id');
    this.userService.updateUserData.subscribe(() => {
      if (this.userService.userDetails === null) {
        this.isLogin = true;
        this.communicationService.dashboardLogoClick(false);
        return;
      }
      this.isLogin = false;
    });
  }

  @HostListener('window:scroll', ['$event'])
  scrollHandler() {
    this.commonService.manageStickyHeader('impressumPageHeader');
  }
}
